// 合同抽取页面
<template>
  <div class="root-contrast">
    <!-- title -->
    <route-name propsRouteName="合同关键词抽取"></route-name>
    <!-- content 内容 -->
    <div class="content">
      <div class="extract">
        <div class="upload-box">
          <p style="color: #222">上传合同：</p>
          <div class="upload">
            <img
              src="/images/AISmart/icon/group.png"
              width="49px"
              height="47px"
              alt=""
            />
            <el-upload
              ref="exUpload"
              class="upload-bth"
              action="#"
              accept=".pdf,.doc,.docx"
              :limit="1"
              :auto-upload="false"
              :on-exceed="exceed"
              :on-change="fileChange"
              :before-upload="fileExtract"
            >
              <el-button size="small" type="danger" plain>选择文件</el-button>
            </el-upload>
            <span style="color: #999; margin-top: 10px"
              >可支持
              .pdf、.doc、.docx、格式文件，上传单个文件大小不超过30M。</span
            >
          </div>
        </div>
        <div>
          <el-button type="danger" @click="docTypeVisi = true"
            >开始抽取</el-button
          >
        </div>
      </div>
      <!-- 选择文档类型弹窗 -->
      <el-dialog title="开始抽取" width="30%" :visible.sync="docTypeVisi">
        <el-form :model="form" ref="tempForm">
          <el-form-item
            label="选择合同类型"
            prop="docType"
            :rules="{
              required: true,
              message: '请选择合同类型',
              trigger: 'blur',
            }"
          >
            <el-select v-model="form.docType" placeholder="请选择合同类型">
              <el-option
                v-for="item of extractTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="docTypeVisi = false">取 消</el-button>
          <el-button type="primary" :loading="loadingBtn" @click="extractDoc"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import RouteName from "@/components/route-name";
// 接口
import {
  ApiMethods,
  postFileTempUpload
} from "../../../assets/js/http-serve/http-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  data () {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      docTypeVisi: false,
      extractTypes: [],
      extractFiles: [],
      form: {
        docType: ""
      },
      loadingBtn: false
    };
  },
  // data end
  methods: {
    // 开始抽取
    async extractDoc () {
      this.$refs.tempForm.validate(vaild => {
        if (vaild) {
          let { extractFiles, form } = this,
            FD = new FormData();
          console.log(extractFiles, form);
          if (extractFiles.length === 0)
            return this.$message.error("请先上传需要被抽取的文档");
          this.loadingBtn = true;
          FD.append("targetStoreId", extractFiles[0].targetId);
          FD.append("fileType", extractFiles[0].fileType);
          FD.append("templateId", form.docType);
          this.smartAPI
            .extractUpload(FD)
            .then(res => {
              if (res.success) {
                this.extractFiles = [];
                this.$router.push("/smartDoc/docExtract/extractList");
              } else {
                if (res.code == 10807) {
                  this.buyDia();
                  return;
                }
                this.$message.error(res.description);
              }
            })
            .finally(() => {
              this.loadingBtn = false;
            });
        }
      });
    },
    exceed (files, fileList) {
      this.$message.warning("仅支持单文件上传,请删除后重新上传");
    },
    fileChange (file, fileList) {
      if (file.status === "ready") {
        let isLt30M = file.size / 1024 / 1024 < 30,
          re = new RegExp("(.doc|.docx|.pdf)$", "i");
        if (!isLt30M) {
          this.$message.error("上传文件大小不能超过 30MB!");
          return false;
        }
        if (!re.test(file.name)) {
          this.$message.error("文件格式只能是 doc / docx /pdf 文件");
          return false;
        }
        this.$refs.exUpload.submit();
      }
    },
    // 文件上传
    fileExtract (file) {
      postFileTempUpload({ file, fileType: 1 })
        .then(data => {
          this.extractFiles[0] = data;
        })
        .catch(err => {
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 合同类型弹窗数据
    getTemps () {
      this.smartAPI.extractTemplates().then(res => {
        if (res.success) {
          this.extractTypes = res.data;
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // 显示购买弹窗
    buyDia () {
      this.$confirm("当前无文档抽取功能使用次数，请前往购买！", "提示", {
        type: "error"
      })
        .then(res => {
          const url = this.globalConfig.domain.accountWeb + "/asset/aiContractChargePage"
          isInDingTalk ? location.href = url : window.open(url);
        })
        .catch(err => {
          // this.$message.error("err", err);
        });
    }
  },
  // methods end
  components: { RouteName },
  created () {
    this.getTemps();
  }
};
</script>

<style scoped lang="less">
.root-contrast {
  height: 100%;
  background-color: #fff;
  .content {
    height: calc(85vh - 36px);
    padding: 16px;
    overflow: auto;
    .extract {
      width: 100%;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .upload-box {
        width: 100%;
        height: 420px;
        padding: 10px 0 0 24px;
        background-color: #efefef;
        border-radius: 2px 2px 2px 2px;
        overflow: auto;
        > p {
          margin-bottom: 15px;
        }
        .upload {
          width: 98%;
          height: 340px;
          padding: 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #ffffff;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #d9d9d9;
          .choose {
            margin: 15px 0;
          }
          > img {
            margin-bottom: 10px;
          }
          .upload-bth {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
          }
        }
      }
      > div:last-child {
        margin-top: 30px;
      }
    }
  }
  /deep/.el-upload-list__item-name {
    width: 15vw;
  }
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc/docExtract/extract.vue